import Color from '@styles/Color';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

const dirMap = {
  vertical: css`
    flex-direction: row;
  `,
  horizontal: css`
    flex-direction: column;
  `,
};

export const ActionButtonWrap = styled.div<{
  transparent?: boolean;
  dir: 'horizontal' | 'vertical';
}>`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 6px;
  border-radius: var(--buttonBorderRadius);
  z-index: 2;
  background-color: ${({ transparent }) =>
    transparent ? 'transparent' : `var(--cardBackgroundColor)`};

  ${({ dir }) => dir && dirMap[dir]}
`;

export const MobileActionBtnWrap = styled(motion.div)`
  width: 100%;
  height: 40px;

  position: fixed;
  bottom: 0;
  left: 0;
  background: ${Color.BLUE_GRAY_8};
  color: white;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  padding: 0 16px;
  border-radius: 0;
  z-index: 2;

  .group {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const MobileActionBtn = styled.button``;

export const ActionButton = styled.button<{
  isEnabled?: boolean;
}>`
  width: 48px;
  height: 48px;
  border-radius: var(--buttonBorderRadius);
  border: 1px solid var(--lineColor);
  background-color: var(--cardBackgroundColor);

  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: background-color 0.2s, border 0.2s;

  svg {
    path {
      fill: ${({ isEnabled }) => isEnabled && 'var(--subTextColor)'};
    }
  }

  &:hover {
    background-color: var(--inkColor);
    border: 1px solid var(--primaryColor);
  }
`;

export const ActionButtonBedge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 24px;
  height: 24px;
  border-radius: 50px;
  background-color: var(--primaryColor);
  color: var(--subColor);
  display: flex;
  justify-content: center;
  align-items: center;
`;
